import { SessionService } from "../../Services";
import { ISidebarViewProps } from "./Sidebar.interfaces";
import { Link } from "react-router-dom";
export default function SidebarView(props: ISidebarViewProps) {
    return (
        <>
            <div className="grid grid-rows-[1fr_9fr] h-full p-5">
                <div>
                    <img
                        src="../../images/whitelogo.webp"
                        alt="logo"
                        className="w-full"
                    />
                </div>
                <div className="grid grid-rows-[8fr_2fr] text-white">
                    <div className="grid content-between">
                        <div>
                            <Link to="/dashboard/home">
                                <div
                                    className={`${
                                        props.btnColor === "Dashboard"
                                            ? "bg-[#489BF6]"
                                            : "hover:bg-[#489BF6] duration-200"
                                    } rounded-md flex p-3 my-2`}
                                    onClick={() => {
                                        props.SetBranch(false);
                                        props.ButtonColor("Dashboard");
                                    }}
                                >
                                    <i className="fa fa-dashboard m-2"></i>
                                    <p className="text-lg">Dashboard</p>
                                </div>
                            </Link>
                            <div
                                className={`${
                                    props.btnColor === "Branch"
                                        ? "bg-[#489BF6]"
                                        : "hover:bg-[#489BF6] duration-200"
                                } cursor-pointer rounded-md flex items-center p-3`}
                                onClick={() => {
                                    props.SetBranch(!props.branch);
                                    props.ButtonColor("Branch");
                                }}
                            >
                                <i className="fa fa-random m-2"></i>
                                <p className="text-lg">Metaverses</p>
                                <i className="fa fa-angle-down ml-8 mr-2"></i>
                            </div>
                            <div
                                className={
                                    props.branch
                                        ? "grid grid-cols-0_1 ml-3 font-mormal font-barlow"
                                        : "hidden"
                                }
                            >
                                <ul className="text-left">
                                    <li
                                        className={`${
                                            props.btnColor === "Branch"
                                                ? "text-[#489BF6] py-5"
                                                : ""
                                        }`}
                                    >
                                        {props.metaverses.map(
                                            (metaverse: any, index: number) => (
                                                <Link
                                                    to={`/dashboard/metaverse/${metaverse.metaverseID._id}`}
                                                    key={index}
                                                >
                                                    <p className="text-lg hover:text-white">
                                                        {
                                                            metaverse
                                                                .metaverseID
                                                                .name
                                                        }
                                                    </p>
                                                </Link>
                                            )
                                        )}
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <Link to="/dashboard/metaverse-users">
                                    <div
                                        className={`${
                                            props.btnColor === "Dashboard User"
                                                ? "bg-[#489BF6]"
                                                : "hover:bg-[#489BF6] duration-200"
                                        } cursor-pointer rounded-md flex items-center my-2 p-3`}
                                        onClick={() => {
                                            props.ButtonColor("Dashboard User");
                                        }}
                                    >
                                        <i className="fa fa-paper-plane m-2"></i>
                                        <p className="text-lg">
                                            Metaverse Users
                                        </p>
                                        {/* <i className="fa fa-angle-down ml-8 mr-2"></i> */}
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div>
                            <Link to="/dashboard/myaccount">
                                <div
                                    className={`${
                                        props.btnColor === "My Account"
                                            ? "bg-[#489BF6]"
                                            : "hover:bg-[#489BF6] duration-200"
                                    } rounded-md flex p-3`}
                                    onClick={() => {
                                        props.SetBranch(false);
                                        props.ButtonColor("My Account");
                                    }}
                                >
                                    <i className="fa fa-user m-2"></i>
                                    <p className="text-lg">My Account</p>
                                </div>
                            </Link>
                            <div
                                className={`${
                                    props.btnColor === "Logout"
                                        ? "bg-[#489BF6] "
                                        : "hover:bg-[#489BF6] duration-200"
                                } rounded-md flex p-3 my-2 cursor-pointer`}
                                onClick={() => {
                                    props.SetBranch(false);
                                    props.ButtonColor("Logout");
                                    SessionService.clear();
                                    window.location.href = "/dashboard/login";
                                }}
                            >
                                <i className="fa fa-power-off m-2"></i>
                                <p className="text-lg">Logout</p>
                            </div>
                        </div>
                    </div>
                    <div className="bg-[#FFFFFF29] text-center font-['roboto'] rounded-md mt-8">
                        <p className="text-sm mt-5 font-semibold">
                            Support 24/7
                        </p>
                        <p className="text-xs font-medium">
                            Contact us anytime
                        </p>
                        <p className="text-[#489BF6] text-sm font-semibold my-5">
                            Start chat
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}
